export const uk = {
    confirm:
        'Уточнение будет удалено навсегда и перестанет показываться во всех объявлениях, для которых оно было добавлено. Если вы хотите убрать уточнение только из текущего объявления, удалите его из списка справа.',
    title: 'Вы уверены, что хотите удалить уточнение?'
};
